/* Vídeos (Stories) — Fiber Academy. Carrossel de cards (N por vez) + modal estilo Stories.
   Custom element <video-stories>, separado do product-stories da página de produto. */
class VideoStories extends HTMLElement {
  constructor() {
    super();
    this.modal = null; this.current = 0; this.slides = []; this.progressBars = [];
    this.soundOn = true;
  }

  connectedCallback() {
    this.cards = [...this.querySelectorAll('.video-stories__card')];
    this.querySelectorAll('.video-stories__media').forEach((m) => {
      m.addEventListener('click', () => this.open(+m.dataset.storyIndex));
    });
    this.setupCardHover();
    this.setupCarousel();
  }

  disconnectedCallback() { this.close(); }

  setupCardHover() {
    if (matchMedia('(hover: none)').matches) return; // touch: só poster
    this.cards.forEach((card) => {
      const v = card.querySelector('.video-stories__card-video');
      if (!v) return;
      card.addEventListener('mouseenter', () => {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        v.play().then(() => v.classList.add('is-playing')).catch(() => {});
      });
      card.addEventListener('mouseleave', () => { v.pause(); v.classList.remove('is-playing'); });
    });
  }

  setupCarousel() {
    this.viewport = this.querySelector('.video-stories__viewport');
    this.track = this.querySelector('.video-stories__track');
    this.prevBtn = this.querySelector('.video-stories__arrow--prev');
    this.nextBtn = this.querySelector('.video-stories__arrow--next');
    this.dotsEl = this.querySelector('.video-stories__dots');
    if (!this.track) return;

    const page = () => this.track.clientWidth + parseFloat(getComputedStyle(this.track).gap || 0);
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' }));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' }));

    const buildDots = () => {
      if (!this.dotsEl) return;
      const pages = Math.max(1, Math.round(this.track.scrollWidth / this.track.clientWidth));
      this.dotsEl.innerHTML = '';
      this._dots = [];
      if (pages <= 1) return;
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Página ' + (i + 1));
        b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }));
        this.dotsEl.appendChild(b); this._dots.push(b);
      }
    };

    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const hasOverflow = scrollWidth - clientWidth > 4;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 4;
      if (this.prevBtn) this.prevBtn.hidden = !hasOverflow || atStart;
      if (this.nextBtn) this.nextBtn.hidden = !hasOverflow || atEnd;
      if (this._dots && this._dots.length) {
        const idx = Math.round(scrollLeft / clientWidth);
        this._dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    };

    this.track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { buildDots(); update(); });
    buildDots(); requestAnimationFrame(update); setTimeout(() => { buildDots(); update(); }, 150);
  }

  /* ---------- MODAL ---------- */
  buildModal() {
    const template = this.querySelector('[data-stories-template]');
    if (!template) return;
    const modal = document.createElement('div');
    modal.className = 'product-stories__modal video-stories__modal';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');

    const stage = document.createElement('div');
    stage.className = 'product-stories__stage';

    const progress = document.createElement('div');
    progress.className = 'product-stories__progress';

    const frag = template.content.cloneNode(true);
    const slideEls = frag.querySelectorAll('.product-stories__slide');
    slideEls.forEach(() => {
      const bar = document.createElement('div');
      bar.className = 'product-stories__progress-bar'; bar.innerHTML = '<span></span>';
      progress.appendChild(bar);
    });
    stage.appendChild(progress);
    stage.appendChild(frag);

    const loading = document.createElement('div');
    loading.className = 'vs-loading';
    loading.innerHTML = '<span class="vs-loading__spinner" role="status" aria-label="Carregando vídeo"></span>';
    stage.appendChild(loading);

    this.caption = document.createElement('div');
    this.caption.className = 'vs-caption';
    stage.appendChild(this.caption);

    const mk = (cls, label, html) => { const b = document.createElement('button'); b.type = 'button'; b.className = cls; b.setAttribute('aria-label', label); b.innerHTML = html; return b; };
    const close = mk('product-stories__close', 'Fechar', '&times;');
    const prev = mk('product-stories__nav product-stories__nav--prev', 'Anterior', '&#8249;');
    const next = mk('product-stories__nav product-stories__nav--next', 'Próximo', '&#8250;');
    this.soundBtn = mk('product-stories__sound', 'Ativar/desativar som',
      '<svg class="vs-ico-on" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM14 3.2v2.06A7 7 0 0 1 14 18.7v2.06A9 9 0 0 0 14 3.2z"/></svg>' +
      '<svg class="vs-ico-muted" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm18.5-1.5L20 6 16.5 9.5 13 6v2.8l2.1 2.1L13 13v2.8l3.5-3.5L20 16l1.5-1.5L18 11z"/></svg>');

    stage.appendChild(close); stage.appendChild(prev); stage.appendChild(next); stage.appendChild(this.soundBtn);
    modal.appendChild(stage);
    document.body.appendChild(modal);

    this.modal = modal;
    this.slides = [...modal.querySelectorAll('.product-stories__slide')];
    this.progressBars = [...progress.children];

    close.addEventListener('click', () => this.close());
    prev.addEventListener('click', () => this.go(this.current - 1));
    next.addEventListener('click', () => this.go(this.current + 1));
    this.soundBtn.addEventListener('click', () => this.toggleSound());
    modal.addEventListener('click', (e) => { if (e.target === modal) this.close(); });

    this.bindKeyboard(); this.bindTouch(stage); this.bindVideoEvents(); this.updateSoundBtn();
  }

  showLoading() { if (this.modal) this.modal.classList.add('is-loading'); }
  hideLoading() { if (this.modal) this.modal.classList.remove('is-loading'); }

  updateCaption() {
    if (!this.caption) return;
    const s = this.slides[this.current];
    const name = s.dataset.name || '';
    const price = s.dataset.price || '';
    const url = s.dataset.url || '';
    let html = '';
    if (name) html += '<p class="vs-caption__name">' + name + '</p>';
    if (price) html += '<p class="vs-caption__price">' + price + '</p>';
    if (url) html += '<a class="vs-caption__link" href="' + url + '">Ver produto</a>';
    this.caption.innerHTML = html;
  }

  bindKeyboard() {
    this._onKey = (e) => {
      if (!this.isOpen()) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.go(this.current - 1);
      if (e.key === 'ArrowRight') this.go(this.current + 1);
    };
    document.addEventListener('keydown', this._onKey);
  }

  bindTouch(stage) {
    let sx = 0, sy = 0;
    stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0]; const dx = t.clientX - sx; const dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(this.current + (dx < 0 ? 1 : -1));
      else if (dy > 80 && Math.abs(dy) > Math.abs(dx)) this.close();
    });
  }

  bindVideoEvents() {
    this.slides.forEach((slide, idx) => {
      const video = slide.querySelector('video');
      if (!video) return;
      video.addEventListener('ended', () => this.go(idx + 1));
      video.addEventListener('waiting', () => { if (idx === this.current) this.showLoading(); });
      video.addEventListener('stalled', () => { if (idx === this.current) this.showLoading(); });
      video.addEventListener('playing', () => { if (idx === this.current) this.hideLoading(); });
      video.addEventListener('canplay', () => { if (idx === this.current && !video.paused) this.hideLoading(); });
      video.addEventListener('timeupdate', () => {
        if (idx !== this.current) return;
        if (video.currentTime > 0) this.hideLoading();
        this.progressBars[idx].firstElementChild.style.width = (video.currentTime / (video.duration || 1)) * 100 + '%';
      });
    });
  }

  playActive(video) {
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
    video.preload = 'auto';
    video.muted = !this.soundOn;
    const p = video.play();
    if (p && p.catch) p.catch(() => { video.muted = true; this.soundOn = false; this.updateSoundBtn(); video.play().catch(() => {}); });
  }

  go(target) {
    if (target < 0) return this.close();
    if (target >= this.slides.length) return this.close();
    this.current = target;
    this.showLoading();
    this.updateCaption();
    this.slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === target) {
        slide.classList.add('is-active');
        try { video.currentTime = 0; } catch (e) {}
        this.playActive(video);
      } else { slide.classList.remove('is-active'); video.pause(); }
      this.progressBars[i].firstElementChild.style.width = i < target ? '100%' : '0%';
    });
  }

  toggleSound() {
    this.soundOn = !this.soundOn;
    const v = this.slides[this.current] && this.slides[this.current].querySelector('video');
    if (v) { v.muted = !this.soundOn; if (this.soundOn) v.play().catch(() => { this.soundOn = false; v.muted = true; this.updateSoundBtn(); }); }
    this.updateSoundBtn();
  }

  updateSoundBtn() {
    if (!this.soundBtn) return;
    this.soundBtn.classList.toggle('is-muted', !this.soundOn);
    this.soundBtn.setAttribute('aria-label', this.soundOn ? 'Desativar som' : 'Ativar som');
  }

  open(index) {
    if (!this.modal) this.buildModal();
    if (!this.modal) return;
    this.soundOn = true;
    this.modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    this.go(index || 0);
    this._trigger = document.activeElement;
    setTimeout(() => { const c = this.modal.querySelector('.product-stories__close'); if (c) c.focus(); }, 30);
  }

  close() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open'); this.hideLoading();
    document.documentElement.style.overflow = '';
    this.slides.forEach((s) => { s.classList.remove('is-active'); const v = s.querySelector('video'); if (v) v.pause(); });
    if (this._trigger && typeof this._trigger.focus === 'function') this._trigger.focus();
  }

  isOpen() { return this.modal && this.modal.classList.contains('is-open'); }
}

if (!customElements.get('video-stories')) customElements.define('video-stories', VideoStories);
